<!-- eslint-disable -->
<template lang="pug">
    transition(name="fade")
        .map-modal.modal.is-active(:class="displayModal && 'is-active'" v-show="displayModal")
            .modal-background(@click="$emit('close')")
            .modal-card(:class="{'continents-modal': isContinentsModal}")
                a(href="javascript://", @click="$emit('close')")
                    svg-icon.cross-icon(name="times" aria-hidden="true")
                .modal-card-body
                    slot(name="body")
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            title: String,
            isContinentsModal: Boolean,
            displayModal: Boolean
        }
    }
</script>

<style lang="scss">
    .modal {
        transition: all 0.3s;
        opacity: 1;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: 1986;
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
    }

    .modal-background {
        background-color: rgba(10, 10, 10, 0.70);
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        box-sizing: inherit;
    }

    .modal-card {
        overflow: visible;
        margin: 0 0;
        border-radius: 7px;
        display: flex;
        flex-direction: column;
        position: relative;

        &.continents-modal {
            width: 768px;
            @media screen and (max-device-width: 940px) {
                width: 519px;
            }

            .modal-card-body {
                padding: 0;
                background-color: rgb(16, 87, 165)!important;
                box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .2);
                height: 90vh;
                @include media($md) {
                    height: 100%;
                }
            }
        }
    }

    .modal-card-body {
        border-radius: 7px;
        background: none $x-color-white;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    .cross-icon {
        font-size: 35px;
        position: absolute;
        z-index: 5;
        top: 10px;
        right: 15px;
        color: $hsl-color-gray-92;
        border-radius: 50%;
        cursor: pointer;
        display: inline-block;
        text-rendering: auto;
        text-align: center;
        vertical-align: top;

        &:hover {
            color: $hsl-color-yellow-66;
        }
    }


</style>